import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/icons/icon-floorplan.webp'
import _imports_1 from '@/assets/icons/checked-white.svg'


const _hoisted_1 = { class: "admin-page-wr" }
const _hoisted_2 = { class: "table-wrapper" }
const _hoisted_3 = { class: "table-default" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "bold" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "content-checked"
}
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", _hoisted_3, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList($setup.tableHeaders, (header) => {
              return _createElementVNode("th", { key: header }, _toDisplayString(header), 1)
            }), 64))
          ])
        ]),
        ($props.houses.length > 0 && !($props.houses.length === 1 && $props.houses[0] === null))
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.houses, (house) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: house._id,
                  onClick: ($event: any) => ($setup.onSelectHouse(house._id, house.area, house.basePrice, house.floorplans[0].url, house.floorplans[0].name, house.name))
                }, [
                  _createElementVNode("td", _hoisted_6, _toDisplayString(house.name), 1),
                  _createElementVNode("td", null, _toDisplayString(house.bedroom || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(house.bathroom.quantity || "-"), 1),
                  _createElementVNode("td", null, _toDisplayString(house.loungeRoom ? house.loungeRoom.quantity : "-"), 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatPrice(house.area || "-", false)) + "sqm", 1),
                  _createElementVNode("td", null, _toDisplayString($setup.formatPrice(house.basePrice || "-")), 1),
                  _cache[1] || (_cache[1] = _createElementVNode("td", { class: "td-floorplan" }, [
                    _createElementVNode("img", {
                      class: "floorplan-svg",
                      src: _imports_0
                    })
                  ], -1)),
                  _createElementVNode("td", {
                    class: _normalizeClass(["td-action", { checked: house._id === $setup.selectedHouseId }])
                  }, [
                    (house._id !== $setup.selectedHouseId)
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 0,
                          class: "badge select",
                          onClick: ($event: any) => ($setup.onSelectHouse(house._id, house.area, house.basePrice, house.floorplans[0].url, house.floorplans[0].name, house.name))
                        }, _toDisplayString($setup.getButtonLabel(house._id)), 9, _hoisted_7))
                      : _createCommentVNode("", true),
                    (house._id === $setup.selectedHouseId)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            class: "icon-checked",
                            src: _imports_1
                          }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ], 2)
                ], 8, _hoisted_5))
              }), 128))
            ]))
          : ($props.houses.length === 1 && $props.houses[0] === null)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_9, [...(_cache[2] || (_cache[2] = [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", {
                    class: "colspan-headers no-data",
                    colspan: "7"
                  }, "The selected builder has no house designs associated with this lot, please update it.")
                ], -1)
              ]))]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_10, [...(_cache[3] || (_cache[3] = [
                _createElementVNode("tr", null, [
                  _createElementVNode("td", {
                    class: "colspan-headers no-data",
                    colspan: "7"
                  }, "No houses available")
                ], -1)
              ]))]))
      ])
    ])
  ]))
}